<template>
  <div class="fit">
    <h4><router-link :to="{ name: 'gci' }">Search GCI</router-link></h4>
    <BrowseGCIResults />
  </div>
</template>

<script>
// @ is an alias to /src
import BrowseGCIResults from "@/components/BrowseGCISearchResults.vue";

export default {
  name: "GCIBrowseResults",
  components: {
    BrowseGCIResults
  },
  metaInfo: {
    title: "GCI Browse Results"
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/buefy.scss";
</style>
